import type React from 'react';

// The FIELD_DATA_ATTR constant defines a custom data attribute used to mark form fields that are relevant
// for form submission. This attribute enables selective targeting of these fields within the document,
// ensuring that only specified elements are considered when gathering form data.
export const FIELD_DATA_ATTR = 'data-bb-field';

export const FIELD_EDITABLE_ATTR = 'data-editable';

export const FIELD_COMP_NAME_ATTR = 'data-field-name';

export const FIELD_ERROR_DATA_ATTR = 'data-bb-error';

export enum FieldBBType {
	text = 'text',
	email = 'email',
	tel = 'tel',
	date = 'date',
	select = 'select',
	hidden = 'hidden',
	search = 'search',
	file = 'file',
}

export enum FieldBBErrorType {
	required = 'required',
	email = 'email',
	tel = 'tel',
	fullName = 'fullName',
	fileSize = 'fileSize',
	invalidFileType = 'invalidFileType',
	genericError = 'genericError',
}

export enum SelectBBOptionsOrder {
	'alphabet' = 'alphabet',
	'random' = 'random',
	'custom' = 'custom',
}

export type TFieldProps = {
	className: string;
	type: FieldBBType;
	name: string;
	placeholder?: string;
	autoComplete?: 'off';
	[FIELD_DATA_ATTR]: string;
	[FIELD_EDITABLE_ATTR]?: string;
	value?: string | number;
	readOnly?: boolean;
	onDoubleClick?: (e: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onFocus?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onClick?: (e: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	style?: React.CSSProperties;
};

export enum DateFormat {
	DDMMYYYY = 'DDMMYYYY',
	MMDDYYYY = 'MMDDYYYY',
	YYYYMMDD = 'YYYYMMDD',
}

export enum DateDelimiter {
	'.' = '.',
	'/' = '/',
	'-' = '-',
}
